// Loop-step row item, e.g. "01 · research" in the #how section.
export function Pill({ index, label, active = false }) {
  return (
    <span className={`pill${active ? " pill-active" : ""}`}>
      <span className="pill-index">{String(index).padStart(2, "0")}</span>
      <span className="pill-label">{label}</span>
    </span>
  );
}
